import Coverage from '@/modules/common/common/models/MID/Coverage'
import PetsHiringInsured from './PetsHiringInsured'

export class PetHiring extends PetsHiringInsured {
  coverages: Coverage[]
  pureBreed: string | undefined
  isLiabilityInsuredPolicyholder: boolean | undefined

  constructor(data: any = {}) {
    super(data)
    this.coverages = data.coverages?.map((c: any) => new Coverage(c)) ?? []
    this.pureBreed = data.pureBreed
    this.isLiabilityInsuredPolicyholder = data.isLiabilityInsuredPolicyholder
  }
}
